<template lang="pug">
  .b2b-timeline
    ods-col.timeline(:span='24', v-for='(event, index) in events',v-if='canSeeUser(event.property)', :key='index')
      div.timeline__left
        div.timeline__point()
        p.timeline__day {{ formatDate(event.eventCreationDate)}}
        p.timeline__time {{ formatDate(event.eventCreationDate, 'hour') }}
      div.timeline__right
        p.timeline__event {{ getEvent(event.event) }}
        p.timeline__property {{ getProperty(event.property) }}
        p.timeline__value {{ event.value }}
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'b2b-timeline',
  props: {
    events: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'invoice'
    }
  },

  data () {
    return {
      isSponsor: false
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'canAdminIndra'
    ])
  },

  methods: {
    ...mapActions([
      'getUserSponsor'
    ]),
    getEvent (code) {
      let key
      if (!code) {
        return ''
      } else {
        switch (this.type) {
          case 'invoice':
            key = 'invoice_detail.events.code.'
            break
          case 'auditory':
            key = 'auditory_detail.events.code.'
            break
          default:
            break
        }
        let message = this.$t(key + code)

        // Comprobamos que el mensaje es un objeto. Si lo es, tenemos que traernos el que tenga la calve vacia
        if (typeof message === 'object') {
          message = message['']
        }

        // Comprobamos que existe mensaje con el codigo traido de BD
        return (message === (key + code)) ? code : message
      }
    },

    canSeeUser (code) {
      return !(code === 'USER' && !this.isSponsor)
    },

    getProperty (code) {
      let key
      if (!code) {
        return ''
      } else {
        switch (this.type) {
          case 'invoice':
            key = 'invoice_detail.events.property.'
            break
          case 'auditory':
            key = 'auditory_detail.events.property.'
            break
          default:
            break
        }
        let message = this.$t(key + code)

        // Comprobamos que el mensaje es un objeto. Si lo es, tenemos que traernos el que tenga la calve vacia
        if (typeof message === 'object') {
          message = message['']
        }

        // Comprobamos que existe mensaje con el codigo traido de BD
        return (message === (key + code)) ? code : message
      }
    },
    formatDate (date, hour) {
      return hour ? moment(date).format('H:mm:ss') : moment(date).format('D/M/YYYY')
    }
  },
  async created () {
    if (!this.canAdminIndra && this.activeUser && this.activeUser.data && this.activeUser.data.projects && this.activeUser.data.projects.length > 0) {
      this.isSponsor = await this.getUserSponsor(this.activeUser.data.projects[0].id)
    } else {
      this.isSponsor = true
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-timeline {
  .timeline {
    .timeline__left {
      width: 11.9rem;
      float: left;
      min-height: 8rem;
      text-align: right;
      border-right: .2rem solid var(--color-txt-secondary);
      padding-right: 4rem;
      box-sizing: border-box;
      .timeline__day,
      .timeline__time {
        font-size: 14px;
        line-height: 1.5;
        color: var(--color-txt-secondary);
        letter-spacing: .07rem;
      }
      .timeline__point {
        width: 1.6rem;
        height: 1.6rem;
        background-color: var(--color-txt-secondary);
        border-radius: 50%;
        position: absolute;
        left: 11rem;
      }
    }
    .timeline__right {
      width: auto;
      float: left;
      padding-left: 4rem;
      .timeline__event {
        font-size: 14px;
        color: var(--color-txt-primary);
        // font-weight: $font-weight-medium;
        line-height: 1.3;
      }
      .timeline__property {
        font-size: 12px;
        line-height: 1.9;
        color: var(--color-txt-primary);
      }
      .timeline__value {
        max-width: rem(580);
        word-break: break-all;
        font-size: 12px;
        line-height: 1.75;
        color: var(--color-txt-secondary);
      }
    }
  }
}
</style>
